import React from 'react';
import './GoalHierarchy.css';

export default function GoalHierarchy() {
  return (
    <section className="goal-hierarchy landing__section" aria-labelledby="goals-heading">
      <div className="landing__column">
        <div className="fade-up">
          <h2 className="goal-hierarchy__heading" id="goals-heading">
            Goals with the work attached.
          </h2>
          <p className="goal-hierarchy__lede">
            A goal isn't a line in a document — it's the projects under it and
            the tasks inside those. Everything connected to the value it came from.
          </p>

          <div className="goal-hierarchy__panel" aria-label="Example goal and task structure">
            <div className="goal-hierarchy__goal">
              <span className="goal-hierarchy__goal-label">Goal</span>
              <span className="goal-hierarchy__goal-text">Ship the first version of the product</span>
              <span className="goal-hierarchy__value-link">↑ Craft</span>
            </div>

            <div className="goal-hierarchy__projects">
              <div className="goal-hierarchy__project">
                <div className="goal-hierarchy__project-header">
                  <span className="goal-hierarchy__project-label">Project</span>
                  <span className="goal-hierarchy__project-name">Backend API</span>
                </div>
                <ul className="goal-hierarchy__tasks" aria-label="Backend API tasks">
                  <li className="goal-hierarchy__task goal-hierarchy__task--done">
                    <span className="goal-hierarchy__task-check" aria-label="Done">✓</span>
                    Set up authentication
                  </li>
                  <li className="goal-hierarchy__task goal-hierarchy__task--done">
                    <span className="goal-hierarchy__task-check" aria-label="Done">✓</span>
                    Write waitlist endpoint
                  </li>
                  <li className="goal-hierarchy__task">
                    <span className="goal-hierarchy__task-check" aria-label="Pending">○</span>
                    Add rate limiting
                  </li>
                </ul>
              </div>

              <div className="goal-hierarchy__project">
                <div className="goal-hierarchy__project-header">
                  <span className="goal-hierarchy__project-label">Project</span>
                  <span className="goal-hierarchy__project-name">Landing page</span>
                </div>
                <ul className="goal-hierarchy__tasks" aria-label="Landing page tasks">
                  <li className="goal-hierarchy__task goal-hierarchy__task--done">
                    <span className="goal-hierarchy__task-check" aria-label="Done">✓</span>
                    Write copy
                  </li>
                  <li className="goal-hierarchy__task">
                    <span className="goal-hierarchy__task-check" aria-label="Pending">○</span>
                    Add screen mockups
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <p className="goal-hierarchy__caption">
            Aspirational view — design in progress.
          </p>
        </div>
      </div>
    </section>
  );
}
